<template>
  <!-- 详情页-锚点导航组件 -->
  <div id="anchorScrollNav" ref="scrollNavRef">
    <div class="showNav" :style="{ display: showNav ? 'block' : 'none' }">
      <div class="page-navigation">
        <span v-for="(anchor, index) in tabsTitleList" :key="index">
          <a
            href="javascript:;"
            v-if="anchor.show"
            @click="goAnchor(index)"
            v-html="anchor.anchorName"
            :class="{ active: anchor.active }"
          ></a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
let vm;
export default {
  name: "anchorScrollNav",
  /*
    必传：  tabsTitleList：[{anchorName: "详情",active: true,show:true/false}]
    必传：  anchorFlag: 父元素中所有锚点元素添加的选择器标识，通过querySelectorAll获取所有锚点元素。如".anchor-box"
    必传：  faBoxId: 父元素盒子的id名,需要监听父盒子的高度变化
*/
  props: ["tabsTitleList", "anchorFlag", "faBoxId"],
  data() {
    return {
      // 是否显示页面顶部导航:当页面滚动至指定位置才显示(设置为页面向下滚动distanceToToppx之后显示锚点导航)
      showNav: false,
      // 海报弹窗显示时，当前页面导航的显示状态
      tempNavStatus: null,
      // 记录当前锚点
      currentNavIndex: 0,
      //   页面内锚点元素列表
      anchorElemsList: [],
      //   各锚点元素的offsetTop：元素到offsetParent（距离元素最近的一个具有定位的祖先元素（relative，absolute，fixed），若无已定位的祖先元素，offsetParent为body）顶部的距离。组件中为距离body顶部的距离
      offsetTopList: [],
    };
  },

  created() {
    vm = this;
    // 监听海报弹窗是否显示，事件随海报遮罩视图显示状态切换触发
    vm.$bus.$on("posterVisibleStatus", (status) => {
      if (status) {
        // 显示海报视图,保存当前导航显示状态,并隐藏导航
        this.tempNavStatus = this.showNav;
        this.showNav = false;
      } else {
        // 隐藏海报视图
        this.showNav = this.tempNavStatus;
      }
    });
  },
  mounted() {
    // 监听父组件盒子高度变化
    this.observeWithResizeObserver();
  },
  beforeDestroy() {
    this.$bus.$off("posterVisibleStatus");
    //离开该页面需要移除这个监听的事件
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    observeWithResizeObserver() {
      const vm = this;
      const element = document.getElementById(vm.faBoxId); // 获取父组件
      const observer = new ResizeObserver((entries) => {
        entries.forEach(() => {
          // 每次父组件盒子高度变化 从新计算每个锚点元素位置
          if (vm.tabsTitleList.length) {
            let scrollY = window.scrollY;
            // 锚点元素列表
            vm.anchorElemsList = document.querySelectorAll(vm.anchorFlag);
            let barTop =
              vm.$refs.scrollNavRef.getBoundingClientRect().top + scrollY;
            vm.offsetTopList = [];
            // 各锚点元素距离body顶部的偏移量
            vm.anchorElemsList.forEach((item) => {
              vm.offsetTopList.push(
                scrollY + item.getBoundingClientRect().top - barTop
              );
            });
            if (!document.onscroll) {
              document.addEventListener("scroll", vm.handleScroll);
            }
            vm.showNav = scrollY >= vm.offsetTopList[0] - 50;
          }
        });
      });
      observer.observe(element);
      // 销毁时移除监听
      this.$once("hook:beforeDestroy", () => {
        observer.disconnect();
      });
    },
    handleScroll(e) {
      // 获取当前文档流的 scrollTop
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      vm.showNav = scrollTop >= vm.offsetTopList[0] - 50; // 判断nav是否显隐
      // 根据视口高度判断那个nav为选中状态
      vm.offsetTopList.forEach((item, index) => {
        if (scrollTop + 45 > item) {
          vm.currentNavIndex = index;
        }
      });
      // 设置导肮高亮状态;
      vm.tabsTitleList.map((item) => {
        item.active = false;
      });
      vm.tabsTitleList[vm.currentNavIndex].active = true;
    },
    // 页面内锚点跳转
    goAnchor(index) {
      let top = Math.abs(this.offsetTopList[index] - 40);
      window.scrollTo({ top });
    },
  },
};
</script>

<style lang="scss">
// 0.顶部吸附导航
.showNav {
  position: fixed;
  width: 100%;
  display: block;
  top: calc(constant(safe-area-inset-top) + 44px) !important;
  top: calc(env(safe-area-inset-top) + 44px) !important;
  // top: 44px;
  left: 0;
  background: #fff;
  z-index: 999;
}

.page-navigation {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
  height: 45px;
  // padding: 0 25px;
  span {
    flex-shrink: 0;
  }
  span:empty {
    display: none;
  }
  a {
    // padding-right: 25px;

    font-size: 15px;
    font-weight: 400;
    color: #333333;
    line-height: 21px;
  }

  a.active {
    font-size: 16px;
    font-weight: 500;
    color: #4a79f1;
    line-height: 23px;
    position: relative;
  }

  a.active::after {
    content: "";
    display: block;
    width: 20px;
    height: 2px;
    background: #397bf9;
    border-radius: 2px;
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
  }

  a:last-child {
    padding-right: 0;
  }
}

// }
</style>
